const Home = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={22}
        height={24}
        fill="none"
        {...props}
    >
        <path
            fill={!!props?.fill ? props.fill : "#000"}
            d="M15.23 23.44c-1.15.01-1.35-.63-1.35-1.45 0-.3-.01-.61-.01-.92V17.4c0-.4.02-.86 0-1.39-.51 0-.96-.04-1.31-.05-1.17 0-2.34-.02-3.51 0-.76.02-1.02.23-1.03 1.02-.03.41 0 .81-.01 1.22 0 1.17.02 2.29.03 3.51.03 1.03-.36 1.62-1.4 1.69-1.53.05-3.25.02-4.78 0-.98.02-1.67-.52-1.63-2.15-.02-2.8.05-6.33.03-9.13 0-1.46.35-2.55 1.43-3.55 2.27-2.09 7.7-7.16 8.22-7.48.89-.74 1.33-.74 2.31.05.42.28 5.85 5.35 8.19 7.55.9.85 1.4 1.83 1.39 3.09-.02 3.05 0 6.11 0 9.16 0 .15 0 .31-.01.46 0 1.25-.5 2.01-2.01 2.05m-3.91-1.77h2.79c1.38.02 1.24-.2 1.25-1.6.04-2.56-.01-4.86.02-7.37.02-1.11-.12-1.89-.79-2.53-2.5-2.39-4.87-4.5-7.37-6.92-.78-.86-1.36-.18-1.57.03-2.45 2.37-4.45 4.26-6.91 6.62-.64.61-1.21 1.74-1.2 2.61.02 2.59 0 7.5.02 8-.03 1.36.66 1.17 1.16 1.16.82 0 1.11 0 1.9.02.8-.02.96-.21.97-.99.02-1.37 0-2.75-.02-4.12 0-1.16.26-1.61.61-1.95.41-.4.96-.57 1.7-.56.1 0 5.44-.03 5.94 0 .97-.04 1.46.8 1.49 1.59.02.38 0 3.3.01 4.42 0 .45.01 1.2 0 1.59Z"
        />
    </svg>
)
export default Home
